module.exports = __webpack_public_path__ + "assets/img/ywbj_banner.fb7ff3e3.png";